module.exports = __webpack_public_path__ + "img/heat.d63190bb.svg";